import { ErrorListOutput } from '../../types';
import moment from 'moment/moment';

interface ProductDefinitionInput {
  id: string;
  state?: string;
  coverageStart: string | null;
}

export interface ProductDefinitionSuccessResponse {
  productDefinition: {
    effectiveDate: string;
    productTypeCode: string;
    productId: string;
    underwritingCompanyId: string;
    underwritingCompanyName: string;
    productVersionId: string;
    productCoverageList: {
      coverageCd: string;
      coverageDescription: string;
      isMandatoryCoverage: boolean;
      limitList: string[];
    }[];
    productDeductibleList: {
      deductibleCd: string;
      deductibleName: string;
      deductibleOptionList: string[];
    }[];
    productPaymentPlanDefinition: {
      paymentPlanName: string;
      policyTermType: string;
      paymentPlanType: string;
      paymentBillingMethod: string;
      downPaymentPct: number;
      reinstatementFeeAmt: number;
      noSuchFundsFeeAmt: number;
      installmentFeeAmt: number;
    };
  };
}

export interface ProductDefinitionErrorResponse {
  productDefinition: ErrorListOutput & {
    effectiveDate: never;
    productTypeCode: never;
    productId: never;
    underwritingCompanyId: never;
    underwritingCompanyName: never;
    productVersionId: never;
    productCoverageList: never;
    productDeductibleList: never;
    productPaymentPlanDefinition: never;
  };
}

export type ProductDefinitionResponse =
  | ProductDefinitionSuccessResponse
  | ProductDefinitionErrorResponse;

export const PRODUCT_DEFINITION = (
  productDefinition: ProductDefinitionInput,
) => {
  const date = productDefinition.coverageStart
    ? moment(productDefinition.coverageStart).format('YYYY-MM-DD')
    : '';
  return `query {
        productDefinition (applicationId: "${productDefinition.id}",
            input: {
            buildingAddressState: "${productDefinition.state || ''}",
            coverageStart: "${date}"
          }
        ) {
          effectiveDate,
          productTypeCode,
          productId,
          underwritingCompanyId,
          underwritingCompanyName,
          productId,
          productVersionId,
          productCoverageList: productCoverageList{
           coverageCd,
            coverageDescription,
            isMandatoryCoverage,
            limitList
          },
          productDeductibleList {
            deductibleCd,
            deductibleName,
            deductibleOptionList
          },
          productPaymentPlanDefinition {
            paymentPlanName,
            policyTermType,
            paymentPlanType,
            paymentBillingMethod,
            downPaymentPct,
            reinstatementFeeAmt,
            paymentBillingMethod,
            noSuchFundsFeeAmt,
            installmentFeeAmt
          }
        }
      }`;
};
